<template>
  <div class="tpehealth-app-layer-table-item-page col-block width-full" :style="{ flex: 1 }">
    <div class="tpehealth-app-layer-table-data-list-container col-block width-full" :style="{ flex: 1 }">
      <div
        class="tpehealth-app-layer-table-data-list-block col-block width-full"
        v-for="(data, dindex) in (datas || [{}])"
        :key="dindex"
        :class="!datas ? ['title'] : option.style ? [option.style === 'striped' ? (data.number % 2 ? 'white' : 'gray') : null, option.style] : []"
        :style="datas && !datas[dindex + 1] ? { flex: 1 } : {}"
      >
        <div class="tpehealth-app-layer-table-data-container row-block stretch">
          <div
            class="tpehealth-app-layer-table-data-block col-block width-full"
            v-for="(option, oindex) in option.options"
            :key="oindex"
            :class="[option.type]"
            :style="option.width ? { width: option.width } : { flex: 1 }"
          >
            <template v-if="option.options">
              <layerTableItem
                :datas="datas ? data[option.key] : null"
                :option="option"
              ></layerTableItem>
            </template>
            <template v-else>
              <div class="tpehealth-app-layer-table-data-cell-container row-block" :class="{ 'flex-start': option.row === 'start', 'flex-end': option.row === 'end' }" :style="{ flex: 1 }">
                <div class="tpehealth-app-layer-table-data-cell-block col-block" :class="{ 'flex-start': option.col === 'start', 'flex-end': option.col === 'end' }" :style="{ flex: 1 }">
                  <template v-if="!datas">
                    <div class="tpehealth-app-layer-table-data-content" v-html="option.title"></div>
                  </template>
                  <template v-else-if="option.type === 'icon'">
                    <div class="tpehealth-app-layer-table-data-icon-container col-block" :class="{ 'flex-start': option.col === 'start', 'flex-end': option.col === 'end' }">
                      <div v-if="option.value" class="tpehealth-app-layer-table-data-content" :class="option.style ? [option.style(option.value(data), data)] : []" v-html="option.value(data)"></div>
                      <img class="tpehealth-app-layer-table-data-icon" :src="option.icon(data)" alt="" :style="{ width: '90px' }">
                    </div>
                  </template>
                  <template v-else>
                    <div class="tpehealth-app-layer-table-data-content" :class="option.style ? [option.style(option.value(data), data)] : []" v-html="option.value(data)"></div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: () => null
    },
    option: {
      type: Object,
      required: true
    }
  },
  name: 'layerTableItem'
}
</script>
